import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import $ from 'jquery';
import HighCharts from 'highcharts';
import numeral from 'numeral';
import 'numeral/locales/it';
import ShowComponent from '../../hocs/ShowComponent';

@ShowComponent
class SavingsGraphComponent extends React.Component {
  componentDidMount() {
    const documentWidth = $(document).width();

    let responsiveWidth = null;
    let responsivePointWidth = '';
    if (documentWidth > 1300) {
      responsivePointWidth = 180;
      responsiveWidth = 490;
    } else if (documentWidth <= 1300 && documentWidth > 1024) {
      responsiveWidth = 490;
      responsivePointWidth = 180;
    } else if (documentWidth <= 1024 && documentWidth > 480) {
      responsivePointWidth = 180;
    } else if (documentWidth <= 480) {
      responsivePointWidth = 100;
    }

    const series = this.props.termInterestSavingsSeries;

    let {
      colorChart,
      colorBackgroundChart,
      colorXAxisChart,
    } = this.props;


    /* Set default colors */
    if (!colorChart || !colorBackgroundChart || !colorXAxisChart) {
      colorChart = '#68a2bb';
      colorBackgroundChart = '#ececec';
      colorXAxisChart = 'grey';
    }

    HighCharts.chart('looptijdrente-savings', {
      chart: {
        type: 'column',
        backgroundColor: colorBackgroundChart,
        height: 300,
        width: responsiveWidth,
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: ['Zonder <br> looptijdrente', 'Met <br> looptijdrente'],
        lineWidth: 3,
        lineColor: colorXAxisChart,
        plotBands: {
          borderColor: colorChart,
        },
        tickLength: 0,
        useHTML: true,
        labels: {
          style: {
            color: colorChart,
            fontSize: 14,
          },
          formatter() {
            const formattedData = numeral(series[1].data[this.pos]).format('$ 0,00');

            return (`
                  <div class="looptijdrente-savings__xAxis">${formattedData}</div>
              `);
          },
        },
      },
      credits: {
        enabled: false,
      },
      yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        min: series[1].data[0] / 2,
        title: {
          text: '',
        },
        labels: {
          enabled: false,
        },
        stackLabels: {
          enabled: false,
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          borderColor: colorChart,
          borderWidth: 2,
          dataLabels: {
            style: {
              whiteSpace: 'unset',
              top: 250,
            },
            verticalAlign: 'bottom',
            enabled: true,
            useHTML: true,
            color: (HighCharts.theme && HighCharts.theme.dataLabelsColor) || 'white',
            formatter() {
              let yPoint = '';
              if (this.series.name === 'korting') {
                yPoint = this.x;
              }

              return `
                  <div class="highcharts-label__container">
                      <span style="color:white">${yPoint}</span>
                  </div>`;
            },
          },
        },
      },
      series: [{
        lineWidth: 5,
        name: series[0].name,
        data: series[0].data,
        pointWidth: responsivePointWidth,
        color: 'rgba(255, 255, 255, 0.0)',
      }, {
        lineWidth: 5,
        name: series[1].name,
        data: series[1].data,
        color: colorChart,
        pointWidth: responsivePointWidth,
      }],
    });
  }

  render() {
    const { classNames } = this.props;

    return (
      <div className={classNames}>
        <div id="looptijdrente-savings" />
      </div>
    );
  }
}

SavingsGraphComponent.propTypes = {
  termInterestSavingsSeries: PropTypes.arrayOf(PropTypes.shape({})),
  classNames: PropTypes.string,
  colorChart: PropTypes.string,
  colorBackgroundChart: PropTypes.string,
  colorXAxisChart: PropTypes.string,
};

SavingsGraphComponent.defaultProps = {
  termInterestSavingsSeries: [],
  classNames: '',
  colorChart: '',
  colorBackgroundChart: '',
  colorXAxisChart: '',
};

export default SavingsGraphComponent;
